export const ar_common = {
  // ... (All previous keys from Header to Footer remain the same)
  home: 'الرئيسية',
  about: 'من نحن',
  contact: 'اتصل بنا',
  bookNow: 'احجز الآن',
  myAccount: 'حسابي',
  heroTitle: 'اكتشف جمال البحر مع رحلاتنا البحرية الاستثنائية',
  heroSubtitle: 'انطلق في مغامرة لا تُنسى عبر المياه الزرقاء الصافية',
  exploreTrips: 'استكشف الرحلات',
  happyCustomers: 'عميل سعيد',
  tripsCompleted: 'رحلة مكتملة',
  yearsExperience: 'سنة خبرة',
  ourTrips: 'رحلاتنا',
  dayTrip: 'الرحلات النهارية', // تم التعديل
  eveningTrip: 'الرحلات المسائية', // تم التعديل
  dayTripDesc: 'استمتع بيوم كامل من السباحة والغطس واستكشاف الجزر',
  eveningTripDesc: 'اختبر غروب الشمس الساحر مع الموسيقى والمرطبات',
  duration: 'المدة',
  price: 'السعر',
  bookTrip: 'احجز الرحلة',
  aboutUs: 'من نحن',
  aboutTitle: 'لماذا تختار فايربوت؟',
  aboutDesc: 'نحن شركة رائدة في تنظيم الرحلات البحرية، نقدم تجارب استثنائية وآمنة في أجمل المواقع البحرية.',
  professionalCrew: 'طاقم محترف',
  professionalCrewDesc: 'فريق ذو خبرة عالية ومدرب على أعلى المستويات',
  modernBoats: 'قوارب حديثة',
  modernBoatsDesc: 'أسطول من القوارب المجهزة بأحدث التقنيات',
  safetyFirst: 'الأمان أولاً',
  safetyFirstDesc: 'معدات أمان متطورة وإجراءات سلامة صارمة',
  fullService: 'خدمة شاملة',
  fullServiceDesc: 'كل ما تحتاجه لرحلة مثالية في مكان واحد',
  contactTitle: 'تواصل معنا',
  contactDesc: 'نحن هنا للإجابة على جميع استفساراتك ومساعدتك في تخطيط رحلتك المثالية',
  getInTouch: 'تواصل معنا',
  address: 'العنوان',
  workingHours: 'ساعات العمل',
  fullName: 'الاسم الكامل',
  email: 'البريد الإلكتروني',
  message: 'الرسالة',
  sendMessage: 'إرسال الرسالة',
  messageSent: 'تم إرسال رسالتك بنجاح',
  messageError: 'تعذّر إرسال رسالتك، حاول مرة أخرى',
  quickLinks: 'روابط سريعة',
  privacyPolicy: 'سياسة الخصوصية',
  refundExchangePolicy: 'سياسة الاستبدال والاسترجاع',
  followUs: 'تابعنا',
  myBookings: 'حجوزاتي',
  settings: 'الإعدادات',
  loggedInAs: 'مسجل دخول باسم',
  chooseTravelDate: 'اختر تاريخ الرحلة',
  
  // Booking Confirmation (using unique keys to avoid conflicts)
  bookingConfirmedSuccess: 'تم تأكيد الحجز!',
  bookingConfirmedCOD: 'تم تأكيد حجزك. ستدفع عند صعود القارب.',
  bookingConfirmedOnline: 'تم تأكيد حجزك وسيتم توجيهك لإتمام الدفع.',
  bookingDetails: 'تفاصيل الحجز',
  orderNumber: 'رقم الطلب',
  tripTitle: 'الرحلة',
  confirmationDate: 'التاريخ',
  confirmationTime: 'الوقت', 
  confirmationPassengers: 'المسافرون',
  person: 'شخص',
  totalAmount: 'المبلغ الإجمالي',
  confirmationPaymentMethod: 'طريقة الدفع',
  cashOnDelivery: 'الدفع عند الاستلام',
  
  // Payment Instructions
  paymentInstructions: 'تعليمات الدفع',
  codInstruction1: 'توجه إلى موقع الإبحار في الوقت المحدد',
  codInstruction2: 'أحضر معك مبلغ المطلوب نقداً',
  codInstruction3: 'ستدفع قبل صعود القارب مباشرة',

  // Bank Transfer
  bankTransferInstructions: 'تعليمات التحويل',
  bankAccountDetails: 'تفاصيل الحساب',
  accountName: 'اسم الحساب',
  bankName: 'اسم البنك',
  accountNumber: 'رقم الحساب',
  iban: 'رقم الآيبان',
  
  // Contact Support
  needHelp: 'تحتاج مساعدة؟',
  contactSupport: 'اتصل بنا',
  
  // Actions
  printTicket: 'طباعة التذكرة',
  closeModal: 'إغلاق',
  
  // Additional Notes
  confirmationEmailSent: 'تم إرسال تأكيد الحجز إلى بريدك الإلكتروني',
  keepOrderNumber: 'احتفظ برقم الطلب للمراجعة',

  // Success Page translations
  successTitle: 'شكراً لك! تم تأكيد حجزك',
  orderDetails: 'تفاصيل الطلب',
  orderCreatedDate: 'تاريخ إنشاء الطلب',
  // tripName, tripDate, tripTime already exist above
  // orderNumber already exists above
  // bookingReference already exists above
  // creditCardTap already exists below in payment methods
  status: 'الحالة',
  // orderProcessing already exists below in Order Status
  nextSteps: 'الخطوات التالية',
  emailConfirmationStep: 'سيتم إرسال تأكيد عبر الرسائل القصيرة/البريد الإلكتروني',
  accountViewStep: 'يمكنك مشاهدة التذكرة في صفحة حجوزاتي',
  arriveEarlyStep: 'يرجى الحضور قبل موعد الانطلاق بـ 30 دقيقة',
  downloadTicket: 'تحميل التذكرة (PDF)',
  ticketNotReadyYet: 'التذكرة غير جاهزة بعد. يرجى المحاولة لاحقاً.',
  ticketWillAppearWhenReady: 'ستظهر التذكرة عند جاهزيتها',
  backToHome: 'العودة للصفحة الرئيسية',
  showFullServerResponse: 'عرض استجابة الخادم كاملة',
  responseAlsoPrintedInConsole: 'هذه الاستجابة مطبوعة أيضاً في وحدة التحكم بالمتصفح',
  verifyingPaymentInProgress: 'جاري التحقق من الدفع، يرجى الانتظار...',
  orderCreatedSuccess: 'تم إنشاء طلبك بنجاح',
  orderCreatedCod: 'تم إنشاء طلبك، وسيتم الدفع عند الصعود إلى القارب.',
  paymentTapSuccess: 'تم الدفع بنجاح. تم تأكيد حجزك.',
  paymentTapPending: 'عملية الدفع معلّقة. سنقوم بإبلاغك عند التأكيد.',
  paymentTapIssue: 'تعذر التحقق من الدفع. إذا تم خصم المبلغ، يرجى التواصل مع الدعم.',
  paymentTamaraIssue: 'فشل في إنشاء رابط الدفع عبر تمارا. الرجاء المحاولة مرة أخرى أو استخدام طريقة دفع أخرى.',
  orderCreatedTamara: 'تم إتمام الدفع بنجاح عبر تمارا! ستصلك رسالة تأكيد قريباً.',
  paymentMethodTamara: 'تمارا - اشتر الآن وادفع لاحقاً',
  paymentCancelledUser: 'تم إلغاء عملية الدفع',
  paymentCancelledUserDesc: 'قمت بإلغاء عملية الدفع. لم يتم خصم أي مبلغ من حسابك.',
  paymentCancelledUserDescTamara: 'قمت بإلغاء الدفع على صفحة تمارا. لم يتم خصم أي مبلغ من حسابك.',
  paymentFailedGateway: 'فشلت عملية الدفع',
  paymentFailedGatewayDesc: 'حدث خطأ أثناء معالجة الدفع. يرجى المحاولة مرة أخرى أو استخدام طريقة دفع أخرى.',
  paymentFailedTamara: 'فشلت عملية الدفع عبر تمارا',
  paymentFailedTamaraDesc: 'حدث خطأ أثناء معالجة الدفع عبر تمارا. يرجى المحاولة مرة أخرى أو استخدام طريقة دفع أخرى.',
    orderRemovedAfterFailure: 'تم حذف هذا الطلب بعد فشل عملية الدفع. يرجى إنشاء حجز جديد إذا كنت ترغب بالمتابعة.',
    orderDetailsUnavailable: 'تفاصيل الطلب لم تعد متاحة لهذا الحجز.',
    retryNotAvailable: 'لا يمكن إعادة محاولة الدفع لهذا الطلب.',
  couldNotVerifyOrder: 'لم نتمكن من التحقق من طلبك. يرجى التواصل معنا.',

  // --- NEW & UPDATED KEYS START HERE ---

  // Trip Types Section
  selectYourAdventure: 'اختر مغامرتك',
  seatsAvailable: 'المقاعد المتاحة',
  seats: 'مقاعد',
  capacity: 'السعة',
  ofTotal: 'من',
  categoriesFound: 'الفئات المتاحة',
  // Authentication & Login
  login: 'تسجيل الدخول',
  phoneNumber: 'رقم الجوال',
  verificationCode: 'كود التحقق',
  firstName: 'الاسم الأول',
  lastName: 'الاسم الأخير',
  optional: 'اختياري',
  required: 'إلزامي',
  verify: 'تحقق',
  welcome: 'مرحباً',
  completeRegistration: 'إنهاء التسجيل',
  enterSaudiPhoneNumber: 'أدخل رقم جوالك السعودي',
  sendVerificationCode: 'إرسال كود التحقق',
  codeSentTo: 'تم إرسال الكود إلى',
  pleaseCompleteYourProfile: 'يرجى إكمال بياناتك الشخصية',
  firstNameRequired: 'الاسم الأول مطلوب',
  lastNameRequired: 'الاسم الأخير مطلوب',
  
  // Authentication Messages
  invalidPhoneNumber: 'رقم الجوال غير صحيح',
  otpSentSuccessfully: 'تم إرسال كود التحقق بنجاح',
  failedToSendOTP: 'فشل في إرسال كود التحقق',
  networkError: 'خطأ في الشبكة',
  invalidOTPCode: 'كود التحقق غير صحيح',
  pleaseCompleteRegistration: 'يرجى إكمال التسجيل',
  loginSuccessful: 'تم تسجيل الدخول بنجاح',
  testMode: 'وضع الاختبار',
  sending: 'جاري الإرسال...',
  verifying: 'جاري التحقق...',
  completing: 'جاري الإنهاء...',
  loginOrRegister: 'تسجيل الدخول أو إنشاء حساب',
  enterPhoneNumber: 'أدخل رقم جوالك لإرسال رمز التحقق',
  or: 'أو',
  forgotPassword: 'نسيت كلمة المرور؟',
  enterYourEmail: 'أدخل بريدك الإلكتروني لإرسال رمز استعادة كلمة المرور',
  enterYourEmailToReceiveCode: 'أدخل بريدك الإلكتروني لاستلام كود التحقق',
  enterYourEmailToResetPassword: 'أدخل بريدك الإلكتروني لإرسال رمز استعادة كلمة المرور',
  sendResetLink: 'إرسال رمز الاستعادة',
  resetEmailSent: 'تم إرسال رمز استعادة كلمة المرور إلى بريدك',
  backToLogin: 'العودة لتسجيل الدخول',
  // Password reset via code
  resetCodeTitle: 'أدخل رمز الاستعادة',
  resetCodeSubtitle: 'أرسلنا رمزاً مكوناً من 6 أرقام إلى بريدك',
  resetCodePlaceholder: '000000',
  verifyCode: 'تحقق من الرمز',
  createNewPassword: 'إنشاء كلمة مرور جديدة',
  newPassword: 'كلمة المرور الجديدة',
  confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
  passwordUpdated: 'تم تحديث كلمة المرور بنجاح',
  codeInvalidOrExpired: 'الرمز غير صحيح أو منتهي',
  
  // User Authentication Status
  welcomeUser: 'أهلاً وسهلاً',
  logout: 'تسجيل الخروج',
  guestUser: 'ضيف',

  // Sub-trip Names
  individualAdventure: 'مغامرات فردية',
  privateAdventure: 'مغامرات خاصة',
  sunsetCruise: 'رحلة الغروب',
  privateKayak: 'الكايو  خاص',
  eveningKayak: 'الكايو  مسائي',

  // Booking Modal
  bookingFor: 'الحجز لـ',
  selectDateTime: 'اختر التاريخ والوقت',
  holdTimer: 'مقعدك محجوز مؤقتاً لمدة',
  seatsReserved: 'المقاعد المحجوزة',
  holdId: 'معرف الحجز',
  timerExpired: 'انتهت صلاحية الحجز',
  timerExpiredMessage: 'للأسف، انتهت مدة الحجز المؤقت (15 دقيقة). يرجى البدء من جديد.',
  step: 'خطوة',
  of: 'من',
  selectTrip: 'اختر الرحلة',
  passengerDetails: 'بيانات الركاب',
  addOns: 'الإضافات',
  phoneVerification: 'توثيق الهاتف',
  payment: 'الدفع',
  confirmation: 'التأكيد',
  previous: 'السابق',
  back: 'رجوع',
  next: 'التالي',
  confirmBooking: 'احجز الآن',
  selectTripType: 'اختر نوع الرحلة',
  sar: 'ريال',
  selectDate: 'اختر التاريخ',
  selectTime: 'اختر الوقت',
  numberOfPassengers: 'عدد الركاب',
  adults: 'البالغون',
  children: 'الأطفال',
  infants: 'الرضّع',
  years: 'سنوات',
  passengerInformation: 'معلومات الركاب',
  passengerName: 'اسم الراكب',
  yearOfBirth: 'سنة الميلاد',
  idType: 'نوع الهوية',
  nationalId: 'هوية وطنية / إقامة',
  passport: 'جواز سفر',
  borderNumber: 'رقم الحدود',
  idNumber: 'رقم الهوية',
  enterBorderNumber: 'أدخل رقم الحدود',
  birthDate: 'تاريخ الميلاد',
  selectBirthDate: 'اختر تاريخ الميلاد',
  day: 'اليوم',
  month: 'الشهر',
  year: 'السنة',
  hijriCalendarToggle: 'التقويم الهجري',
  hijri: 'هجري',
  gregorian: 'ميلادي',
  hijriCalendar: 'التقويم: هجري',
  gregorianCalendar: 'التقويم: ميلادي',
  borderGuardNoticeTitle: 'تنبيه:',
  borderGuardNotice: 'وفق تعليمات حرس الحدود، يرجى إدخال بيانات المرافقين بدقة لإصدار تصريح الإبحار.',
  phoneCase: 'حافظة جوال ضد الماء',
  each: 'للقطعة',
  meal: 'وجبة على متن القارب',
  total: 'الإجمالي',
  processing: 'جاري المعالجة...',
  payNow: 'ادفع الآن',
  paymentRetryFailed: 'فشل في إعادة محاولة الدفع. الرجاء المحاولة مرة أخرى.',
  paymentNotCompleted: 'لم يكتمل الدفع',
  paymentNotCompletedDesc: 'لم تكتمل عملية الدفع. يمكنك إعادة المحاولة الآن لإتمام حجزك.',
  paymentFailed: 'فشل الدفع',
  bookingConfirmed: 'تم تأكيد الحجز!',
  bookingConfirmationMessage: 'شكرًا لك! تم حجز رحلتك بنجاح. لقد تم إرسال رسالة تأكيد إلى هاتفك.',
  bookingReference: 'مرجع الحجز',
  done: 'تم',
  date: 'التاريخ',
  time: 'الوقت',
  passengers: 'الركاب',
  phone: 'الهاتف',
  invalidVerificationCode: 'رمز التحقق غير صالح. الرجاء المحاولة مرة أخرى.',
  verifyPhoneNumber: 'توثيق رقم الهاتف',
  changePhoneNumber: 'تغيير رقم الهاتف',
  enterVerificationCode: 'أدخل رمز التحقق (6 أرقام)',
  forTestingUseCode: 'للتجربة، استخدم الرمز: 123456',
  verificationCodeSentTo: 'تم إرسال رمز التحقق إلى',
  pleaseEnterMobile: 'الرجاء إدخال رقم هاتفك المحمول لتوثيق حجزك. سنرسل لك رمز تحقق مكون من 6 أرقام.',
  pricing: 'التسعير',
  
  // Pricing and Payment
  adultPrice: 'سعر البالغ',
  childPrice: 'سعر الطفل',
  infantPrice: 'سعر الرضيع',
  free: 'مجاني',
    included: 'مشمول',
    fullBoatBooking: 'حجز القارب كامل',
  summary: 'ملخص الحجز',
  subtotal: 'المجموع الفرعي',
  groupDiscount: 'خصم المجموعات',
  groupDiscountHint: 'احجز مع مجموعة واحصل على خصومات مميزة!',
  addOnsTotal: 'مجموع الإضافات',
  paymentMethod: 'طريقة الدفع',
  payWithApplePay: 'ادفع عبر Apple Pay',
  payWithTabby: 'الدفع بواسطة تابي',
  cardNumber: 'رقم البطاقة',
  cardExpiry: 'MM/YY',
  cardCVC: 'CVC',
  cardMada: 'بطاقة / مدى',
  visa: 'فيزا',
  mada: 'مدى',
  tabby: 'تابي',
  applePay: 'Apple Pay',

  // Common
  loading: 'جاري التحميل...',
  success: 'تم بنجاح',
  error: 'حدث خطأ',
  tryAgain: 'حاول مرة أخرى',
  close: 'إغلاق',
  available: 'متاح',
  noTripsAvailable: 'لا توجد رحلات متاحة حالياً',
  noSlotsAvailable: 'لا توجد أوقات متاحة في هذا التاريخ',
  pleaseSelectAnotherDate: 'يرجى اختيار تاريخ آخر',
  
  // Cancel Page Helpers
  howCanWeHelp: 'كيف يمكننا المساعدة؟',
  checkCardBalance: 'تأكد من أن بطاقتك تحتوي على رصيد كافٍ',
  verifyCardDetails: 'تحقق من صحة بيانات البطاقة',
  enableOnlinePayment: 'تأكد من تفعيل الدفع الإلكتروني على بطاقتك',
  tryAnotherPaymentMethod: 'جرب طريقة دفع أخرى',
  havingPaymentDifficulty: 'هل تواجه صعوبة في إتمام الدفع؟',

  // Extras Step - only new keys
  additionalServices: 'الخدمات الإضافية',
  selectOptionalExtras: 'اختر الإضافات الاختيارية لتحسين تجربتك',
  selectedExtras: 'الإضافات المختارة',
  extrasTotal: 'مجموع الإضافات',
  noExtrasAvailable: 'لا توجد إضافات متاحة حالياً',
  enterPassengerDetails: 'أدخل معلومات الركاب وبيانات الاتصال',
  contactName: 'اسم جهة الاتصال',
  enterContactName: 'أدخل اسم جهة الاتصال',
  contactEmail: 'بريد جهة الاتصال',
  enterContactEmail: 'أدخل بريد جهة الاتصال',
  tripSummary: 'ملخص الرحلة',
  trip: 'الرحلة',
  currency: 'ر.س',

  // Passenger Count Step - new keys only
  passengerCount: 'عدد الركاب',
  selectPassengerCount: 'اختر عدد الركاب وشاهد ملخص الأسعار',
  priceSummary: 'ملخص الأسعار',
  minimumPassengersNotice: 'الحد الأدنى للحجز في هذه الرحلة هو {{min}} ركاب.',

  // Passenger Details Step - new keys only
  contactInformation: 'معلومات الاتصال',
  adult: 'بالغ',
  child: 'طفل',
  infant: 'رضيع',
  enterPassengerName: 'أدخل اسم الراكب',
  birthYear: 'سنة الميلاد',
  selectBirthYear: 'اختر سنة الميلاد',
  enterIdNumber: 'أدخل رقم الهوية',

  // Payment Step
  selectPaymentMethod: 'اختر طريقة الدفع',
  choosePreferredPayment: 'اختر طريقة الدفع المفضلة لإتمام حجزك',
  bookingSummary: 'ملخص الحجز',
  tripType: 'نوع الرحلة',
  passengersCount: 'الركاب',
  persons: 'أشخاص',
  timeSlot: 'الوقت',
  addonsTotal: 'الإضافات',
  sarCurrency: 'ر.س',
  grandTotal: 'المجموع',
  tax: 'الضريبة',
  totalExcludingTax: 'المجموع بدون ضريبة',
  includingTax: 'شامل الضريبة',
  excludingTax: 'غير شامل الضريبة',
  paymentMethodLabel: 'طريقة الدفع',
  loadingPaymentMethods: 'جاري تحميل طرق الدفع...',
  // Discounts UI
  availableDiscounts: 'الخصومات المتاحة',
  childDiscount: 'خصم الطفل',
  infantPriceLabel: 'سعر الرضيع',
  
  // Order Creation
  pleaseFillAllFields: 'يرجى ملء جميع الحقول المطلوبة',
  creatingOrder: 'جاري إنشاء الطلب',
  proceedToPayment: 'المتابعة للدفع',
  orderCreationFailed: 'فشل في إنشاء الطلب',

  // Validation Messages
  pleaseCompleteContactInfo: 'يرجى ملء جميع بيانات الاتصال (الاسم والبريد الإلكتروني)',
  contactNameLettersOnly: 'اسم جهة الاتصال يجب أن يحتوي على أحرف فقط',
  pleaseEnterValidEmail: 'يرجى إدخال بريد إلكتروني صالح',
  pleaseEnterRealEmail: 'يرجى إدخال بريد إلكتروني حقيقي',
  pleaseFillAllPassengerData: 'يرجى ملء بيانات جميع المسافرين. مطلوب: {{expected}}, موجود: {{actual}}',
  pleaseFillAllAdultData: 'يرجى ملء جميع البيانات المطلوبة للبالغين',
  pleaseFillAllChildData: 'يرجى ملء جميع البيانات المطلوبة للأطفال',
  pleaseFillAllInfantData: 'يرجى ملء جميع البيانات المطلوبة للرُضع',
  nameLettersOnly: 'الاسم يجب أن يحتوي على أحرف فقط',
  invalidBirthYear: 'سنة الميلاد غير صالحة',
  mustBeAdult: 'يجب أن يكون بالغاً (12 سنة أو أكثر)',
  mustBeChild: 'يجب أن يكون بين 2-11 سنة',
  mustBeInfant: 'يجب أن يكون أقل من سنتين',
  nationalIdMustBe10Digits: 'رقم الهوية الوطنية يجب أن يكون 10 أرقام',
  borderNumberMustBe10Digits: 'رقم الحدود يجب أن يكون 10 أرقام',

  // Authentication - New
  loginWithPhone: 'تسجيل الدخول برقم الجوال',
  loginWithEmail: 'تسجيل الدخول بالإيميل',
  saudiPhoneOnly: 'أرقام سعودية فقط (مثال: 05XXXXXXXX)',
  enterEmailPassword: 'أدخل الإيميل وكلمة المرور',
  enterEmail: 'أدخل البريد الإلكتروني',
  enterPassword: 'أدخل كلمة المرور',
  confirmPassword: 'تأكيد كلمة المرور',
  createNewAccount: 'إنشاء حساب جديد',
  fillDetailsBelow: 'املأ البيانات أدناه',
  alreadyHaveAccount: 'لديك حساب بالفعل؟ سجل دخول',
  
  // Validation messages - New
  passwordRequired: 'كلمة المرور مطلوبة',
  passwordMinLength: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
  passwordMismatch: 'كلمة المرور غير متطابقة',
  invalidEmail: 'البريد الإلكتروني غير صالح',
  verified: 'موثق',
  
  // Error messages - Enhanced
  phoneAlreadyExists: 'رقم الجوال مسجل مسبقاً. يرجى تسجيل الدخول بدلاً من التسجيل.',
  emailAlreadyExists: 'البريد الإلكتروني مسجل مسبقاً. يرجى استخدام بريد إلكتروني مختلف.',
  emailNotFound: 'البريد الإلكتروني غير مسجل. يرجى التحقق من البريد أو إنشاء حساب جديد.',
  incorrectPassword: 'كلمة المرور غير صحيحة. يرجى المحاولة مرة أخرى.',
  invalidCredentials: 'بيانات تسجيل الدخول غير صحيحة. يرجى التحقق من البريد وكلمة المرور.',
  invalidData: 'البيانات المدخلة غير صحيحة. يرجى المحاولة مرة أخرى.',
  
  // Messages - New
  loginSuccess: 'تم تسجيل الدخول بنجاح',
  registrationFailed: 'فشل في التسجيل',
  authenticationRequired: 'يلزم تسجيل الدخول',
  pleaseLoginToContinue: 'يرجى تسجيل الدخول للمتابعة',
  
  // Toast messages - New
  otpSendFailed: 'فشل في إرسال الرمز',
  accountCreatedSuccessfully: 'تم إنشاء الحساب بنجاح',
  registrationCompleteMessage: 'يرجى إدخال اسمك لإكمال التسجيل',
  testingCode: 'للتجربة',
  
  // Placeholders and labels - New
  phoneNumberLabel: 'رقم الجوال',
  phoneNumberPlaceholder: 'رقم الجوال (05XXXXXXXX)',
  otpPlaceholder: '000000',
  passwordPlaceholder: 'أدخل كلمة المرور',
  confirmPasswordPlaceholder: 'تأكيد كلمة المرور',
  accountCreationNote: 'إذا لم يكن لديك حساب، سيتم إنشاء حساب جديد لك تلقائياً',
  fillDataBelow: 'املأ البيانات أدناه',
  createNewAccountWithPhone: 'لإنشاء حساب جديد، استخدم تسجيل الدخول برقم الجوال',
  verifiedLabel: 'محقق',
  
  // Additional keys for missing translations
  emailRequired: 'البريد الإلكتروني مطلوب',
  resendCode: 'إعادة إرسال الرمز',
  emailUpdatedSuccessfully: 'تم تحديث البريد الإلكتروني بنجاح',
  emailConflictInfo: 'هذا البريد مرتبط بحساب آخر. تم تسجيل الدخول بدون تغييره',
  
  // Unified Payment System - New
  paymentMethodSelect: 'اختر طريقة الدفع',
  allPaymentMethods: 'جميع طرق الدفع المتاحة',
  paymentGatewayTitle: 'طرق الدفع المفعلة',
  paymentProcessing: 'جاري معالجة الدفع...',
  orderCreatedSuccessfully: 'تم إنشاء الطلب بنجاح',
  paymentGatewayError: 'خطأ في بوابة الدفع',
  paymentMethodRequired: 'يرجى اختيار طريقة الدفع',
  
  // Payment Methods - Enhanced
  bankTransfer: 'حوالة مصرفية مباشرة',
  chequePayment: 'مدفوعات الشيكات',
  creditCardTap: 'بطاقة ائتمان (Tap)',
  onlinePayment: 'دفع إلكتروني',
  
  // Order Status
  orderProcessing: 'قيد المعالجة',
  orderOnHold: 'معلّق',
  orderPending: 'بانتظار الدفع',
  orderCompleted: 'مكتمل',
  orderCancelled: 'ملغي',
  
  // Enhanced Payment Instructions
  codInstruction1Enhanced: 'احضر قبل موعد الرحلة بـ 30 دقيقة',
  codInstruction2Enhanced: 'أحضر معك هوية صالحة',
  codInstruction3Enhanced: 'أحضر المبلغ نقداً (ريال سعودي فقط)',
  
  // Enhanced Booking Confirmation
  bookingConfirmedCODEnhanced: 'سيتم الدفع نقداً عند وصولك لنقطة الانطلاق',
  bookingConfirmedOnlineEnhanced: 'يرجى إكمال عملية الدفع الإلكتروني',
  
  // Enhanced Actions
  printTicketEnhanced: 'طباعة التذكرة',
  proceedToPaymentEnhanced: 'المتابعة للدفع',
  
  // Additional Enhanced Info
  confirmationEmailSentEnhanced: 'ستصلك رسالة تأكيد على بريدك الإلكتروني',
  keepOrderNumberEnhanced: 'احتفظ برقم الطلب للمتابعة',
  needHelpEnhanced: 'هل تحتاج مساعدة؟',
  contactSupportEnhanced: 'اتصل بخدمة العملاء',
  
  // My Bookings Page (new keys only)
  viewManageBookings: 'عرض وإدارة حجوزاتك',
  allBookings: 'جميع الحجوزات',
  noBookingsFound: 'لا توجد حجوزات',
  noBookingsDescription: 'ليس لديك أي حجوزات حتى الآن. ابدأ بحجز رحلتك الأولى!',
  tripDate: 'تاريخ الرحلة',
  tripTime: 'وقت الرحلة',
  viewDetails: 'عرض التفاصيل',
  loadMore: 'تحميل المزيد',
  loadingMore: 'جاري تحميل المزيد',
  scrollForMore: 'اسحب للأسفل لتحميل المزيد',
  allBookingsLoaded: 'تم تحميل جميع الحجوزات',
  showing: 'عرض',
  bookings: 'حجوزات',
  loadMoreNotImplementedYet: 'قريباً: تحميل المزيد',
  errorDownloadingTicket: 'خطأ في تحميل التذكرة',
  failedToLoadBookings: 'فشل تحميل الحجوزات',
  retry: 'إعادة المحاولة',
  
  // Booking Status
  statusCompleted: 'مكتمل',
  statusProcessing: 'قيد المعالجة',
  statusPending: 'بانتظار الدفع',
  statusOnHold: 'معلّق',
  statusCancelled: 'ملغي',
  statusFailed: 'فشل',
  statusRefunded: 'مسترد',
  
  // My Account Page (new keys only)
  manageProfileBookings: 'إدارة الملف الشخصي والحجوزات',
  member: 'عضو',
  memberSince: 'عضو منذ',
  bookingStatistics: 'إحصائيات الحجوزات',
  totalBookings: 'إجمالي الحجوزات',
  totalSpent: 'إجمالي الإنفاق',
  quickActions: 'إجراءات سريعة',
  viewAllBookings: 'عرض جميع الحجوزات',
  bookNewTrip: 'احجز رحلة جديدة',
  supportComingSoon: 'قريباً: مركز الدعم',
  confirmLogout: 'هل أنت متأكد من تسجيل الخروج؟',
  logoutSuccess: 'تم تسجيل الخروج بنجاح',
  
  // Settings Page (new keys only)
  profileInformation: 'معلومات الملف الشخصي',
  profileUpdated: 'تم تحديث الملف الشخصي',
  errorUpdatingProfile: 'خطأ في تحديث الملف الشخصي',
  currentPassword: 'كلمة المرور الحالية',
  passwordsMismatch: 'كلمتا المرور غير متطابقتين',
  passwordTooShort: 'كلمة المرور قصيرة جداً',
  passwordChanged: 'تم تغيير كلمة المرور بنجاح',
  errorChangingPassword: 'خطأ في تغيير كلمة المرور',
  change: 'تغيير',
  changePassword: 'تغيير كلمة المرور',
  notifications: 'الإشعارات',
  emailNotifications: 'إشعارات البريد الإلكتروني',
  emailNotificationsDesc: 'استلم إشعارات الحجوزات عبر البريد',
  smsNotifications: 'إشعارات الرسائل النصية',
  smsNotificationsDesc: 'استلم رسائل نصية عن حجوزاتك',
  marketingEmails: 'رسائل التسويق',
  marketingEmailsDesc: 'استلم العروض والتحديثات',
  savePreferences: 'حفظ التفضيلات',
  notificationsUpdated: 'تم تحديث الإشعارات',
  errorUpdatingNotifications: 'خطأ في تحديث الإشعارات',
  dangerZone: 'منطقة الخطر',
  dangerZoneDesc: 'حذف الحساب عملية نهائية ولا يمكن التراجع عنها',
  deleteAccount: 'حذف الحساب',
  confirmDeleteAccount: 'هل أنت متأكد من حذف حسابك نهائياً؟',
  accountDeletionNotImplemented: 'قريباً: حذف الحساب',
  
  // Auth Related
  loginRequired: 'تسجيل الدخول مطلوب',
  pleaseLoginToViewAccount: 'الرجاء تسجيل الدخول لعرض حسابك',
  notProvided: 'غير متوفر',
  
  // Tickets Page (new)
  myTickets: 'تذاكري',
  viewPrintTickets: 'عرض وطباعة تذاكرك',
  backToBookings: 'العودة إلى الحجوزات',
  backToTickets: 'العودة إلى التذاكر',
  allTickets: 'جميع التذاكر',
  noTicketsFound: 'لا توجد تذاكر',
  noTicketsDescription: 'ليس لديك أي تذاكر حتى الآن',
  showingTickets: 'عرض {{count}} من {{total}} تذكرة',
  errorLoadingTickets: 'خطأ في تحميل التذاكر',
  ticketNotFound: 'لم يتم العثور على التذكرة',
  viewTicket: 'عرض التذكرة',
  downloadPDF: 'تحميل PDF',
  
  // Security messages
  mustLoginToViewTicket: 'يجب تسجيل الدخول لعرض التذكرة',
  ticketNotYours: 'هذه التذكرة لا تخصك',
  invalidOrUsedLink: 'رابط غير صالح أو تم استخدامه مسبقاً',
  failedToVerifyLink: 'فشل التحقق من الرابط',
  invalidLinkNoToken: 'رابط غير صالح - يجب أن يحتوي على رمز التحقق',
  
  // Ticket Card (only new keys, removed duplicates)
  boatTripTicket: 'تذكرة رحلة بحرية',
  ticketNotAvailable: 'التذكرة غير متاحة',
  tripDetails: 'تفاصيل الرحلة',
  tripName: 'اسم الرحلة',
  pricingSummary: 'ملخص الأسعار',
  customerInformation: 'معلومات العميل',
  customerName: 'اسم العميل',
  orderStatus: 'حالة الطلب',
  created: 'تم الإنشاء',
  paid: 'مدفوع',
  pricingDetails: 'تفاصيل الأسعار',
  basePrice: 'السعر الأساسي',
  discount: 'الخصم',
  addons: 'الإضافات',
  
  // Passenger Types
  passengerType_adult: 'بالغ',
  passengerType_child: 'طفل',
  passengerType_infant: 'رضيع',
  
  // ID Types
  idType_national_id: 'هوية وطنية',
  idType_passport: 'جواز سفر',
  idType_border_number: 'رقم الحدود',
  idType_other: 'أخرى',
  
  // Order Status
  status_processing: 'قيد المعالجة',
  status_completed: 'مكتملة',
  status_pending: 'معلقة',
  status_cancelled: 'ملغاة',
  
  // Trip Details Modal (only new keys)
  departureTime: 'وقت المغادرة',
  totalPassengers: 'إجمالي الركاب',
  people: 'أشخاص',
  hoursRange_day: '6-8 ساعات',
  hoursRange_evening: '3-4 ساعات',
  userId: 'رقم المستخدم',
  locationMap: 'خريطة الموقع',
  characters: 'حرف',
  contactInfo: 'تواصل معنا',
  today: 'اليوم',
  for: 'لعدد',
  to: 'إلى',
  andAbove: 'وأكثر',
  ofAdultPrice: 'من سعر البالغ',
  reload: 'إعادة تحميل',
  
  // Coupon Keys
  haveCoupon: 'لديك كوبون خصم؟',
  appliedCoupon: 'الكوبون المطبق',
  enterCouponCode: 'أدخل كود الكوبون',
  apply: 'تطبيق',
  removeCoupon: 'إزالة الكوبون',
  couponDiscount: 'خصم الكوبون',
  couponHint: 'سيتم التحقق من صلاحية الكوبون وتطبيقه على المنتجات المختارة',
  pleaseEnterCouponCode: 'الرجاء إدخال كود الكوبون',
  invalidCoupon: 'كوبون غير صالح أو منتهي الصلاحية',
  couponApplied: 'تم تطبيق الكوبون بنجاح',
  couponRemoved: 'تم إزالة الكوبون',
  bookingDataRestored: 'تم استعادة بيانات الحجز السابقة',
  
  // Pricing Details (Unified)
  subtotalExTax: 'قيمة الرحلة (بدون ضريبة)',
  totalExTax: 'الإجمالي (بدون ضريبة)',
  totalInclTax: 'الإجمالي (شامل الضريبة)',
  shipping: 'الشحن',
  
  // Validation Messages
  fieldRequired: 'هذا الحقل مطلوب',
  nameTooShort: 'الاسم قصير جداً (3 أحرف على الأقل)',
  
  // Additional UI Keys
  completed: 'مكتملة',
  pending: 'معلقة',
  support: 'الدعم',
  managePreferences: 'إدارة التفضيلات',
  
};

export default ar_common;
